// src/components/common/ToastProvider.jsx
import { Toaster } from 'sonner';
import { useTheme } from '../../context/ThemeContext';
import { C, SHADOW } from '../../theme/tokens';

/**
 * Provider global para notificaciones Toast usando Sonner.
 * Sigue al tema activo: los colores salen de los tokens.
 */
export default function ToastProvider() {
  const { isDark } = useTheme();

  return (
    <Toaster
      position="top-right"
      expand={false}
      richColors
      theme={isDark ? 'dark' : 'light'}
      toastOptions={{
        style: {
          background: C.card,
          color: C.text,
          border: `1px solid ${C.border}`,
          boxShadow: SHADOW.md,
        },
        className: '',
        descriptionClassName: '',
        duration: 4000,
      }}
    />
  );
}
